import { type AnyAction, combineReducers } from 'redux';

import type { BrandKit } from 'js/src/client';
import {
    setBrandKitsLoading,
    setSelectedBrandKitId,
    setTeamBrandKitsCount,
    storeBrandKits,
} from 'js/src/data/brand-kits/brand-kits-actions';
import { resetSelectedBrandKit } from 'js/src/data/brand-kits-editor/brand-kits-editor-actions';
import type { PlainJsStoreOrmData } from 'js/src/data/plain-js-store-orm';
import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';
import type { DeepReadonly } from 'js/src/libs/consts';

type StoredBrandKit = DeepReadonly<BrandKit>;

export function list(
    state: PlainJsStoreOrmData<StoredBrandKit, number> = PlainJsStoreORM.createEmpty<
        StoredBrandKit,
        number
    >().data,
    action: AnyAction,
) {
    if (storeBrandKits.match(action)) {
        const orm = PlainJsStoreORM.createEmpty<StoredBrandKit, number>();

        action.payload.brandKits.forEach((brandKit) => {
            orm.pushItem(brandKit, 'id');
        });
        return orm.data;
    }

    return state;
}

export function loading(state = true, action: AnyAction) {
    if (setBrandKitsLoading.match(action)) {
        return action.payload.flag;
    }
    return state;
}

export function selectedBrandKitId(state: number | null = null, action: AnyAction) {
    if (setSelectedBrandKitId.match(action)) {
        return action.payload;
    }
    if (resetSelectedBrandKit.match(action)) {
        return null;
    }
    return state;
}

export function teamCount(state: number | null = null, action: AnyAction) {
    if (setTeamBrandKitsCount.match(action)) {
        return action.payload;
    }
    return state;
}

export const brandKits = combineReducers({
    list,
    loading,
    selectedBrandKitId,
    teamCount,
});

export type BrandKitsState = ReturnType<typeof brandKits>;
